import { IEditPropertyProps } from './IEditPropertyProps';
import * as React from 'react';
import { FunctionComponent, useState } from 'react';
import { EditValueGrid } from './EditValueGrid';
import { AplixInput } from '../../../../components';

export const EditIntegerValue: FunctionComponent<IEditPropertyProps> = ({
    save,
    property,
    validateRequired,
}) => {
    const [value, setValue] = useState(property.value || '');
    const [errorMessage, setErrorMessage] = useState();

    const trySaveValue = () => {
        const integerValue = parseInt(value, 10);

        if (!isNaN(integerValue)) {
            save(integerValue.toString());
        } else {
            setValue(value);
            setErrorMessage('Bitte geben sie eine gültige Ganzzahl ein');
        }
    };

    const isValid = !validateRequired || !property.isRequired || !!value;

    return (
        <EditValueGrid save={trySaveValue} isValid={isValid} property={property}>
            <AplixInput
                id="value"
                label={property.label}
                value={value}
                fullWidth
                autoFocus
                required={property.isRequired}
                showKeyboardAdornment
                showBarCodeAdornment
                onChange={(event) => setValue(event.target.value)}
                type={'number'}
                errorMessage={errorMessage}
            />
        </EditValueGrid>
    );
};
